import React from 'react'
import { render, screen } from '@testing-library/react'
import MiniCard from '../MiniCard'
import { MiniCardProps } from '../types.d'

const baseProps: MiniCardProps = {
  borderColor: 'dark',
  description: 'Description',
  elevation: 'raised',
  heading: 'Heading'
}

describe('Mini Card Tests', () => {
  it('Should Render MiniCard with No Accent and Gray BG', () => {
    render(
      <MiniCard
        {...baseProps}
        backgroundColor='bg-gray-0'
        accentColor='null'
        accentPosition='null'
      />
    )

    // Get MiniCard container element by class name
    const minicard = screen.getByTestId('minicard')
    expect(minicard).toBeTruthy()
    expect(minicard).toHaveClass(
      'bg-gray-0',
      'border-card-dark',
      'shadow-raised'
    )

    // Get H5 element
    const heading = screen.getByRole(`heading`, { level: 5 })
    expect(heading).toBeTruthy()
    expect(heading.classList.contains('text-default')).toBe(true)
    expect(heading.textContent).toBe('Heading')

    // Get Paragraph element By Text
    const description = screen.getByTestId('description')
    expect(description).toBeTruthy()
    expect(description.classList.contains('text-gray-100')).toBe(true)
    expect(description.textContent).toBe('Description')

    // Get Accent by Test ID
    const accent = screen.queryByTestId('accent')
    expect(accent).toBeNull()
  })

  it('Should Render MiniCard with Top Blue Accent and White BG', () => {
    render(
      <MiniCard
        {...baseProps}
        backgroundColor='bg-white'
        accentColor='blue-75'
        accentPosition='top'
      />
    )

    // Get MiniCard container element by class name
    const minicard = screen.getByTestId('minicard')
    expect(minicard).toBeTruthy()
    expect(minicard).toHaveClass(
      'bg-white',
      'border-card-dark',
      'shadow-raised'
    )

    // Get H5 element
    const heading = screen.getByRole(`heading`, { level: 5 })
    expect(heading).toBeTruthy()
    expect(heading.classList.contains('text-default')).toBe(true)
    expect(heading.textContent).toBe('Heading')

    // Get Paragraph element By Text
    const description = screen.getByTestId('description')
    expect(description).toBeTruthy()
    expect(description.classList.contains('text-gray-100')).toBe(true)
    expect(description.textContent).toBe('Description')

    // Get Accent by Test ID
    const accent = screen.getByTestId('accent')
    expect(accent).toBeTruthy()
    expect(accent).toHaveClass(
      'relative',
      'rounded-tl-[10px]',
      'rounded-tr-[10px]',
      'bg-blue-75'
    )
  })

  it('Should Render MiniCard with Top Yellow Accent and White BG', () => {
    render(
      <MiniCard
        {...baseProps}
        backgroundColor='bg-white'
        accentColor='yellow-50'
        accentPosition='top'
      />
    )

    // Get MiniCard container element by class name
    const minicard = screen.getByTestId('minicard')
    expect(minicard).toBeTruthy()
    expect(minicard).toHaveClass(
      'bg-white',
      'border-card-dark',
      'shadow-raised'
    )

    // Get H5 element
    const heading = screen.getByRole(`heading`, { level: 5 })
    expect(heading).toBeTruthy()
    expect(heading.classList.contains('text-default')).toBe(true)
    expect(heading.textContent).toBe('Heading')

    // Get Paragraph element By Text
    const description = screen.getByTestId('description')
    expect(description).toBeTruthy()
    expect(description.classList.contains('text-gray-100')).toBe(true)
    expect(description.textContent).toBe('Description')

    // Get Accent by Test ID
    const accent = screen.getByTestId('accent')
    expect(accent).toBeTruthy()
    expect(accent).toHaveClass(
      'relative',
      'rounded-tl-[10px]',
      'rounded-tr-[10px]',
      'bg-yellow-50'
    )
  })

  it('Should Render MiniCard with Bottom Brand (Orange) Accent and White BG', () => {
    render(
      <MiniCard
        {...baseProps}
        backgroundColor='bg-white'
        accentColor='brand-50'
        accentPosition='bottom'
      />
    )

    // Get MiniCard container element by class name
    const minicard = screen.getByTestId('minicard')
    expect(minicard).toBeTruthy()
    expect(minicard).toHaveClass(
      'bg-white',
      'border-card-dark',
      'shadow-raised'
    )

    // Get H5 element
    const heading = screen.getByRole(`heading`, { level: 5 })
    expect(heading).toBeTruthy()
    expect(heading.classList.contains('text-default')).toBe(true)
    expect(heading.textContent).toBe('Heading')

    // Get Paragraph element By Text
    const description = screen.getByTestId('description')
    expect(description).toBeTruthy()
    expect(description.classList.contains('text-gray-100')).toBe(true)
    expect(description.textContent).toBe('Description')

    // Get Accent by Test ID
    const accent = screen.getByTestId('accent')
    expect(accent).toBeTruthy()
    expect(accent).toHaveClass(
      'relative',
      'rounded-bl-[10px]',
      'rounded-br-[10px]',
      'bg-brand-50'
    )
  })
})
